<template>
  <div class="chart" :class="{ small: isSmall }">
    <!-- <header>
      <b>
        Ukraina sõja teema tõmbab päevavalgele ka Eesti riigi valukohti.
        Küsisime poliitikutelt, kas see, et siin elavatel Venemaa kodanikel
        (erinevalt näiteks Lätist-Leedust) on õigus hääletada Eestis kohalike
        omavalitsuste valimistel, on praeguses poliitilises olukorras normaalne?
        Kas selle muutmiseks tuleks midagi ette võtta?
      </b>
    </header> -->

    <main>
      <section v-for="row in contentData">
        <img :src="row.image" :alt="row.title" />
        <strong>{{ row.title }}</strong>
        <small>{{ row.subtitle }}</small>
        <div v-html="row.content"></div>
      </section>
    </main>
  </div>
</template>

<style scoped>
.chart {
  --section-color: #0064fa;
  --section-secondary-color: #0000ba;
  --section-tertiary-color: #a5e6e9;
  --line: #d5d8dd;
  --gray: #717c8e;
  --lightest: #eef3f6;
  --text-color: #262626;

  width: 100%;
  display: flex;
  flex-direction: column;

  position: relative;

  font-family: GT Eesti, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  color: var(--text-color);
  line-height: 1;
}

.chart.small {
  font-size: 14px;
}

main {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-rows: min-content;
  gap: 2em 1em;

  margin-top: 1em;
}

.small main {
  grid-template-columns: 1fr;
}

main > section {
  display: flex;
  flex-direction: column;

  box-sizing: border-box;
  padding: 0.5em;

  background-color: #f6f8fa;

  border-radius: 6px;
}

.chart:not(.small) main > section:last-of-type {
  grid-column: 1 / span 2;
}

section strong {
  font-size: 1.25em;

  margin: 0.5em 0;
}

section small {
  font-size: 1em;
  font-weight: 300;
}

section div {
  font-family: Charter, serif;
}

section img {
  width: 300px;
  max-width: 100%;
  border-radius: 4px;
}
</style>

<style>
.chart section div p {
  font-size: 16px !important;
  line-height: 1.35 !important;
}

.chart.small section div p {
  font-size: 13px !important;
}
</style>

<script setup>
import { ref, computed, onMounted, onUnmounted, inject, nextTick } from "vue";

//
const containerElement = inject("containerElement");
const width = ref(0);
const isSmall = ref(false);

const contentData = [
  {
    title: "Anti Poolamets",
    subtitle: "Riigikogu liige (EKRE)",
    content: `<p>EKRE ei pea põhjendatuks, et Eesti kodakondsuseta inimesed – nii halli passi omanikud ehk kodakondsuseta isikud kui ka Vene kodanikud saaksid kohalikel valimistel oma hääle anda. Kodakondsuse üks tähtsamaid omadusi ongi riigivõimu teostamine valimiste kaudu. Vene kodanikele valimisõiguse andmine oli 1990ndate lõpu suur viga. Seda surusid peale nn inimõiguse komissarid ja paraku lasid Isamaa jt erakonnad sellel sündida. Ikka usus, et ehk saab järeleandlikkusega Moskva-meelsetele inimõiguskomissaridele meeldida. Läti keeldus väärikalt. Kui keegi on otsustanud Vene kodakondsuse kasuks, siis need isikud saavad saatkondades valida Vene riigiduumat. Ülekaalukalt on nad toetanud Putinit ja Ühtset Venemaad. See kinnitab, et Eesti pealinnas määravad võimu Ühtse Venemaa valijad. Samal ajal ei ole mittekodanikel kohustust minna ajateenistusse. Praegune olukord ei soosi Eesti kodakondsuse omandamist ning devalveerib selle väärtust, sest teistel on kõik niigi lihtsalt käes, aga kohustusi vähem kui kodanikel. Oleks aeg valimistel osalemise õigus jätta üksnes Eesti kodanikele.</p>`,
  },
  {
    title: "Raivo Tamm",
    subtitle: "Riigikogu liige (Isamaa) ",
    content: `<p>Riigikaitse poolelt on oluline küsimus kolmandate riikide kodanike õigus osaleda kohalikel valimistel. See ei ole ainult demokraatia, vaid ka julgeolekuküsimus.
Senine laiendatud valimisõigus kohalikel valimistel on toonud kaasa integratsiooni pidurdumise, kuigi ühiskonnana oleme seadnud endale eesmärgiks mittekodanike integreerimise.</p>
<p>On oluline, kuidas või millega need mittekodanikud tõestavad oma lojaalsust Eesti Vabariigile. Sama laieneb Eestisse tulla soovivatele Vene kodanikele, kelle puhul on vajalik veenduda, et nad tõepoolest ei toeta Venemaa agressiooni Ukrainas. Kuidas me teame aga valimisõigust omavate mittekodanike tegelikku meelsust? Sama oluline on relvalubade peatamine Valgevene ja kolmandate riikide kodanikele. Kui ühel heal päeval Nõukogude dessantväelase vormis tööle ilmuv mittekodanik omab ka relvaluba, kas saame olla kindlad, et oleme reageerinud neile probleemidele ennetavalt? Need on küsimused, millele peame vaatama ausalt otsa ja mille lahendamist ei ole enam võimalik lükata kaugesse tulevikku.</p>`,
  },
  {
    title: "Marti Soosaar",
    subtitle: "Eestimaa Rohelised juhatuse liige",
    content: `<p>Kahtlemata on küsimus, miks võõra riigi kodanikud saavad meil kohalikke omavalitsusi valida, painutanud palju päid juba palju aastaid. Mingite konfliktide vältimise hirmus toona selline otsus tehti ja eks selle otsuse vilju oleme saanud aastakümneid nautida nii Tallinnas kui ka Ida-Virumaal, kus muukeelse valijate pahameele hirmus on tehtud hulk eestimeelsetele inimestele kummalisi otsuseid. Koolides on saanud möllata umbkeelsed direktorid, haridussüsteemi riigikeelseks viimist on torpedeeritud mõeldaval ja mõeldamatul moel. Uue aja trend on see, et Narvas on ootamatult tekkinud kogukond, kelle kultuurilise identiteedi alustalaks on punase viisnurgaga tanki mulaaž ning KOV ainult laiutab käsi.</p>
<p>Kui aga nüüd mõelda, kas peaks süsteemi muutma hakkama, tuleb silmas pidada kahte asja. Esiteks, kohalikud valimised on alles 2025. aastal. Ilmselt on hetkel selle sõjaga seoses pakilisemaid teemasid. Näiteks relvade ära korjamine Vene passiga inimestelt ja kuritegeliku Moskva patriarhaadi kiriku kohaliku filiaali tegevuse keelustamine. Teiseks, täna inimestelt õigusi vähemaks võttes me muukeelsete seast uusi Eesti sõpru kindlasti ei leia.</p>`,
  },
  {
    title: "Eduard Odinets",
    subtitle: "Riigikogu põhiseaduskomisjoni esimees (SDE)",
    content: `<p>Eesti põhiseadus ütleb, et kohaliku omavalitsuse volikogu valimistel on hääleõiguslikud selle omavalitsuse maa-alal püsivalt elavad isikud. Olen seisukohal, et me peame lähtuma eeskätt põhiseaduse mõttest. Ehk siis teisisõnu on Eestis püsivalt elavatel välismaalastel samuti hääletamisõigus. Ja seda sõltumata nende päritolumaast või sellest, mis kodakondsus neil hetkel on.</p>
<p>Üle 70 000 hääleõigusliku Venemaa kodaniku on valinud kodukohaks Eesti. Nad on sidunud oma elu Eestimaaga, täites kõik vajalikud eeldused, et olla käsitletud püsielanikuna. Veelgi enam – suur osa neist on Eestis sündinud ja siin kogu elu elanud, panustanud kohalikku ellu, aga ka laiemalt riigi arengusse töö ja maksude kaudu. Kas see annab neile õiguse osaleda kohaliku esinduskogu valimisel ja selle kaudu mõjutada oma linna või valla elukorraldust? Arvan, et loomulikult annab.</p>
<p>Tõsi, poliitiline olukord on muutunud ja Venemaa on agressorriik. Kuid kas kuritegeliku naaberriigi režiimi tegude eest peaksime käsitlema kaasvastutajatena kõiki, kelle taskus on agressorriigi pass? Kas naturalisatsiooni ja lõimumisprotsessile Eestis aitaks tõesti kaasa kollektiivse süü veeretamine kõigile, kelle passil on agressorriigi vapp? Või käivitame hoopis vastupidise efekti, kui piirame kümnete tuhandete siinsete püsielanike õigusi poliitilisele eneseteostusele? Minu hinnangul oleks sellise rahulolematuse õhutamine Eesti jaoks suurem julgeolekurisk kui kohalike omavalitsuste valimised. Veelgi enam – julgen väita, et sellised otsused, protsessid ja tagajärjed oleks nimelt see, mida vaenulik naaberriik taotleb Ukraina sõja kõrvalmõjuna, n-ö spillover-efektina – destabiliseerida lähinaabruses olevaid riike. Seda kinki pole mõtet Kremli režiimile teha.</p>`,
  },
  {
    title: "Jaanus Karilaid",
    subtitle: "Riigikogu Keskerakonna fraktsiooni esimees",
    content: `<p>Teatud ühiskonnagrupi tühistamisega me globaalseid probleeme ei lahenda. Eestis elavatel Vene Föderatsiooni kodanikel peab jääma õigus kohalikku elu puudutavates küsimustes kaasa rääkida. Inimesed, kes maksavad riigile makse ja austavad siinset komberuumi, tahavad reeglina linna või valla arengus sõna sekka öelda. Teedeehitus, jäätmemajandus, heakorra tagamine – need teemad mõjutavad meie inimeste igapäevaelu. Teatud poliitikute soov lülitada otsustusprotsessist välja Eestis elavad Vene rahvusest kodanikud vaid suurendab rahvuspõhist lõhet. Lojaalsus Eesti põhiseadusele ja väärtushinnangud käivad mööda inimesi, mitte mööda rahvusi. Eestis elab ligi 150 eri riigi kodanikke. Meie riik on nii tugev, et saame kõik üheskoos hakkama.</p>`,
  },
];

contentData.forEach((row) => {
  const splitName = row.title.split(" ");
  row.image =
    "https://v.postimees.ee/graafikud/2022/m6ttekoda1/img/" +
    splitName.join("-") +
    ".jpg";
});

// *** methods ***

function onResize() {
  const bounds = containerElement.getBoundingClientRect();
  width.value = bounds.width;
  isSmall.value = bounds.width < 555;
}

// Vue lifecycle

onMounted(() => {
  //
  window.addEventListener("resize", onResize);
  onResize();

  // const htmlElement = document.querySelector("html");
  // const isPhone = htmlElement.classList.contains("device-phone");
  // console.log("is phone", isPhone);
});

onUnmounted(() => {
  window.removeEventListener("resize", onResize);
});
</script>
